export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si cancela la operación, se cerrará sin completar la operación."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de que desea cancelar la operación?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sí, cancelar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, mantener activa"])}
}